import { render } from "./user-info.vue?vue&type=template&id=7c316e83&scoped=true&ts=true"
import script from "./user-info.vue?vue&type=script&lang=ts"
export * from "./user-info.vue?vue&type=script&lang=ts"

import "./user-info.vue?vue&type=style&index=0&id=7c316e83&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c316e83"]])

export default __exports__